<template>
  <div>
    <HomeBanner />
    <div class="container p-8 mx-auto mt-10 max-w-7xl" v-if="settings">
      <div class="grid grid-cols-2 gap-4 md:grid-cols-4" v-if="vendors">
        <router-link
          :to="{
            name: 'VendorHome',
            params: {
              id: vendor.id,
              slug: vendor.name
                ? sanitizeTitle(vendor.name)
                : sanitizeTitle(vendor.slug),
            },
          }"
          class="flex flex-row items-center"
          v-for="vendor in vendors"
          :key="vendor.id"
        >
          <div
            class="flex items-center justify-center w-10 h-10 p-2 rounded-full md:w-16 md:h-16"
            :style="{ 'background-color': vendor.color }"
          >
            <img
              v-if="vendor"
              :src="vendor.logo"
              class="md:w-10 md:h-10"
              alt=""
            />
          </div>
          <div class="ml-2">
            <h1 class="text-sm font-bold">{{ vendor.name }}</h1>
            <p class="mt-1 text-xs font-light text-gray-500">
              {{ truncate(vendor.description, 40) }}
            </p>
          </div>
        </router-link>
      </div>
      <!--<div class="container mx-auto mt-20 bg-blue-50 rounded-2xl md:max-w-7xl">-->
      <!--  <div class="flex flex-row">-->
      <!--    <div class="p-5 mr-10 md:w-6/12 md:p-9">-->
      <!--      <h1 class="text-base font-extrabold text-black md:text-3xl">-->
      <!--        {{ $t("landingpageJoin") }}-->
      <!--      </h1>-->
      <!--      <p-->
      <!--        class="mt-1 mb-2 text-xs font-light text-gray-500 md:text-sm md:w-96"-->
      <!--      >-->
      <!--        {{ $t("landingpageJoinSubHeader") }}-->
      <!--      </p>-->
      <!--      <a-->
      <!--        :style="{ 'background-color': settings.colors.primaryColor }"-->
      <!--        :href="`${this.$store.state.baseUrl}register/vendor`"-->
      <!--        target="__blank"-->
      <!--        class="flex items-center justify-center h-10 px-2 py-2 mt-5 mb-5 text-xs font-light text-center text-white rounded-full w-30 md:w-44 md:text-base md:h-14"-->
      <!--      >-->
      <!--        {{ $t("landingpageSellerHeader") }}</a-->
      <!--      >-->
      <!--      <hr class="mt-2" />-->
      <!--      <div class="flex justify-between mt-3">-->
      <!--        <div class="flex">-->
      <!--          <img src="/img/icons/money.svg" class="w-5 h-5" alt="" />-->
      <!--          <div class="ml-2">-->
      <!--            <h1 class="text-xs font-medium md:text-sm">-->
      <!--              {{ $t("landingpageSellerFeat1") }}-->
      <!--            </h1>-->
      <!--            <p class="text-xs font-light text-gray-500">-->
      <!--              {{ $t("landingpageSellerFeat3") }}-->
      <!--            </p>-->
      <!--          </div>-->
      <!--        </div>-->
      <!--        <div class="flex">-->
      <!--          <img-->
      <!--            src="/img/icons/list.svg"-->
      <!--            class="w-5 h-5 font-light rotate-180"-->
      <!--            alt=""-->
      <!--          />-->
      <!--          <div class="ml-2">-->
      <!--            <h1 class="text-xs font-medium md:text-sm">-->
      <!--              {{ $t("landingpageSellerFeat2") }}-->
      <!--            </h1>-->
      <!--            <p class="text-xs font-light text-gray-500">-->
      <!--              {{ $t("landingpageSellerFeat4") }}-->
      <!--            </p>-->
      <!--          </div>-->
      <!--        </div>-->
      <!--      </div>-->
      <!--    </div>-->
      <!--    <img-->
      <!--      src="/img/woman.JPG"-->
      <!--      class="hidden w-6/12 rounded-r-2xl md:h-80 md:flex"-->
      <!--      alt=""-->
      <!--    />-->
      <!--  </div>-->
      <!--</div>-->
      <div class="container mx-auto mt-20 md:max-w-7xl">
        <div
          class="relative overflow-hidden bg-white rounded-3xl shadow-2xl border border-gray-100"
        >
          <div class="flex flex-col lg:flex-row">
            <!-- Content Section -->
            <div class="flex-1 p-8 lg:p-12">
              <div class="max-w-xl">
                <h1
                  class="text-2xl font-bold text-gray-900 lg:text-4xl leading-tight mb-6"
                >
                  {{ $t("landingpageJoin") }}
                </h1>

                <p class="text-lg text-gray-600 mb-8 leading-relaxed">
                  {{ $t("landingpageJoinSubHeader") }}
                </p>

                <a
                  :href="`${this.$store.state.baseUrl}register/vendor`"
                  target="_blank"
                  class="inline-flex items-center px-8 py-4 text-lg font-semibold text-white rounded-2xl transition-all duration-300 transform hover:scale-105 hover:shadow-xl focus:outline-none focus:ring-4 focus:ring-green-500/30 mb-12"
                  :style="{ background: settings.colors.primaryColor }"
                >
                  {{ $t("landingpageSellerHeader") }}
                  <svg
                    class="w-5 h-5 ml-3"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M17 8l4 4m0 0l-4 4m4-4H3"
                    ></path>
                  </svg>
                </a>

                <div
                  class="w-full h-px bg-gradient-to-r from-transparent via-gray-300 to-transparent mb-8"
                ></div>

                <div class="grid md:grid-cols-2 gap-8">
                  <div class="group">
                    <div
                      class="flex items-start space-x-4 p-6 bg-gray-50 rounded-2xl hover:bg-white hover:shadow-lg transition-all duration-300 border border-gray-100"
                    >
                      <div class="flex-shrink-0 mt-1">
                        <div
                          class="w-12 h-12 bg-blue-100 rounded-xl flex items-center justify-center"
                        >
                          <img
                            src="/img/icons/money.svg"
                            class="w-6 h-6"
                            alt=""
                          />
                        </div>
                      </div>
                      <div>
                        <h3 class="text-lg font-semibold text-gray-900 mb-2">
                          {{ $t("landingpageSellerFeat1") }}
                        </h3>
                        <p class="text-gray-600 leading-relaxed">
                          {{ $t("landingpageSellerFeat3") }}
                        </p>
                      </div>
                    </div>
                  </div>

                  <div class="group">
                    <div
                      class="flex items-start space-x-4 p-6 bg-gray-50 rounded-2xl hover:bg-white hover:shadow-lg transition-all duration-300 border border-gray-100"
                    >
                      <div class="flex-shrink-0 mt-1">
                        <div
                          class="w-12 h-12 bg-blue-100 rounded-xl flex items-center justify-center"
                        >
                          <img
                            src="/img/icons/list.svg"
                            class="w-6 h-6 rotate-180"
                            alt=""
                          />
                        </div>
                      </div>
                      <div>
                        <h3 class="text-lg font-semibold text-gray-900 mb-2">
                          {{ $t("landingpageSellerFeat2") }}
                        </h3>
                        <p class="text-gray-600 leading-relaxed">
                          {{ $t("landingpageSellerFeat4") }}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Image Section -->
            <div class="lg:w-6/12">
              <div class="relative h-64 lg:h-full lg:min-h-[500px]">
                <img
                  src="/img/woman.JPG"
                  class="w-full h-full object-cover rounded-b-3xl lg:rounded-b-none lg:rounded-r-3xl"
                  alt=""
                />
                <div
                  class="absolute inset-0 bg-gradient-to-t from-black/10 via-transparent to-transparent lg:bg-gradient-to-l lg:from-black/5 rounded-b-3xl lg:rounded-b-none lg:rounded-r-3xl"
                ></div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        class="container flex flex-col items-center justify-center mx-auto my-20 md:max-w-7xl"
      >
        <h1 class="text-base font-bold tracking-wide text-center md:text-3xl">
          {{ $t("landingpageRide.landingpageRiderHeader") }}
        </h1>
        <p
          class="mt-2 text-xs font-light tracking-wide text-center text-gray-500 md:text-sm md:w-96"
        >
          {{ $t("landingpageRide.landingpageRiderSubHeader") }}
        </p>
        <a
          :style="{ 'background-color': settings.colors.primaryColor }"
          :href="`${this.$store.state.baseUrl}register/driver`"
          target="__blank"
          class="flex items-center justify-center h-10 px-2 py-2 mt-5 mb-5 text-xs font-light text-center text-white rounded-full w-30 md:w-40 md:text-base md:h-14"
          >{{ $t("landingpageRide.landingpageRiderButton") }}</a
        >
      </div>
    </div>
    <!--<div class="mt-5 bg-blue-50">-->
    <!--  <div class="container max-w-full mx-auto">-->
    <!--    <div class="grid grid-cols-1 md:gap-5 py-14 md:grid-cols-2">-->
    <!--      <div>-->
    <!--        <img-->
    <!--          src="/img/phone.png"-->
    <!--          class="mx-auto md:w-72 md:h-72 h-52 w-52"-->
    <!--          alt=""-->
    <!--        />-->
    <!--      </div>-->
    <!--      <div class="p-5 md:w-9/12">-->
    <!--        <h1 class="text-xl font-bold tracking-wide md:text-3xl">-->
    <!--          {{ $t("downloadPage.header") }}-->
    <!--        </h1>-->
    <!--        <p class="my-3 text-sm font-light tracking-wide text-gray-500">-->
    <!--          {{ $t("downloadPage.subHeader") }}-->
    <!--        </p>-->
    <!-- <div
                        class="flex items-center justify-between w-full p-1 mt-4 bg-white border border-blue-100 rounded-full">
                        <input class="w-full p-2 border-none rounded-full placeholder:font-light placeholder:text-sm"
                            v-model="search" type="text" placeholder="(+233) 12345 4563" />
                        <div class="w-56 p-2 bg-blue-800 rounded-full cursor-pointer ">
                            <p class="text-sm font-light text-white md:text-base">Text me the app</p>
                        </div>
                    </div> -->
    <!-- <p class="my-3 text-xs font-light text-gray-500">We will send a text message to your phone with a
                        download link.</p> -->
    <!--        <hr />-->
    <!--        <div class="flex flex-row mt-6" v-if="settings">-->
    <!--          <a :href="settings.strings.androidDownloadLink" target="__blank"-->
    <!--            ><img src="/img/play-store.png" class="h-9 md:h-20"-->
    <!--          /></a>-->
    <!--          <a :href="settings.strings.iosDownloadLink" target="__blank"-->
    <!--            ><img src="/img/app-store.png" class="h-9 md:h-20"-->
    <!--          /></a>-->
    <!--        </div>-->
    <!--      </div>-->
    <!--    </div>-->
    <!--  </div>-->
    <!--</div>-->
    <div class="mt-5 bg-gradient-to-br from-gray-50 via-white to-green-50">
      <div class="container max-w-7xl mx-auto px-4">
        <div
          class="grid grid-cols-1 lg:grid-cols-2 gap-12 py-16 lg:py-20 items-center"
        >
          <!-- Image Section -->
          <div class="relative order-2 lg:order-1">
            <div class="relative flex justify-center lg:justify-start">
              <!-- Background decorative elements -->
              <div class="absolute inset-0 flex items-center justify-center">
                <div
                  class="w-80 h-80 bg-gradient-to-br from-green-100 to-green-200 rounded-full opacity-20 blur-3xl"
                ></div>
              </div>

              <!-- Phone container with modern styling -->
              <div class="relative z-10 p-8 rounded-3xl">
                <div class="relative">
                  <img
                    src="/img/phone.png"
                    class="w-82 h-82 lg:w-100 lg:h-100 object-contain mx-auto drop-shadow-2xl"
                    alt=""
                  />
                </div>
              </div>
            </div>
          </div>

          <!-- Content Section -->
          <div class="order-1 lg:order-2 space-y-8">
            <div class="space-y-6">
              <!-- Header -->
              <div>
                <h1
                  class="text-3xl lg:text-4xl xl:text-5xl font-bold text-gray-900 leading-tight"
                >
                  {{ $t("downloadPage.header") }}
                </h1>
              </div>

              <!-- Subtitle -->
              <p
                class="text-lg lg:text-xl text-gray-600 leading-relaxed max-w-2xl"
              >
                {{ $t("downloadPage.subHeader") }}
              </p>
            </div>

            <!-- Divider -->
            <div
              class="w-24 h-1 bg-gradient-to-r from-green-500 to-green-600 rounded-full"
            ></div>

            <!-- Download Section -->
            <div class="space-y-6" v-if="settings">
              <div
                class="text-sm font-medium text-gray-700 uppercase tracking-wider"
              >
                Download Now
              </div>

              <div class="flex flex-col sm:flex-row gap-4">
                <!-- Google Play Store -->
                <a
                  :href="settings.strings.androidDownloadLink"
                  target="__blank"
                >
                  <img src="/img/play-store.png" class="h-9 md:h-20" />
                </a>

                <!-- App Store -->
                <a :href="settings.strings.iosDownloadLink" target="__blank">
                  <img src="/img/app-store.png" class="h-9 md:h-20" />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import HomeBanner from "@/components/Default/HomeBanner.vue";
export default {
  name: "HomeView",

  components: {
    HomeBanner,
  },
  data() {
    return {
      vendors: null,
      settings: null,
      // base_url: this.$store.state.baseUrl,
      base_url: this.$store.state.baseUrl,
      search: null,
      types: null,
    };
  },
  mounted() {
    let selectedLanguage = localStorage.getItem("selectedLanguage");
    const headers = {
      lang: selectedLanguage,
    };
    this.$store.commit("loading", true);
    axios
      .get(this.base_url + "api/vendor/types", { headers })
      .then((response) => {
        this.vendors = response.data;
        this.$store.commit("loading", false);
        // console.log(this.vendors)
      })
      .catch((error) => console.log(error));

    this.$store.dispatch("fetchSettings", this.items).then(() => {
      this.settings = this.$store.state.settings;
      this.currency = this.settings.strings.currency;
      // console.log(this.settings)
    });
  },

  methods: {
    truncate(str, n) {
      return str.length > n ? str.substr(0, n - 1) + "..." : str;
    },

    sanitizeTitle(title) {
      var slug = "";
      // Change to lower case
      var titleLower = title.toLowerCase();
      // Letter "e"
      slug = titleLower.replace(/e|é|è|ẽ|ẻ|ẹ|ê|ế|ề|ễ|ể|ệ/gi, "e");
      // Letter "a"
      slug = slug.replace(/a|á|à|ã|ả|ạ|ă|ắ|ằ|ẵ|ẳ|ặ|â|ấ|ầ|ẫ|ẩ|ậ/gi, "a");
      // Letter "o"
      slug = slug.replace(/o|ó|ò|õ|ỏ|ọ|ô|ố|ồ|ỗ|ổ|ộ|ơ|ớ|ờ|ỡ|ở|ợ/gi, "o");
      // Letter "u"
      slug = slug.replace(/u|ú|ù|ũ|ủ|ụ|ư|ứ|ừ|ữ|ử|ự/gi, "u");
      // Letter "d"
      slug = slug.replace(/đ/gi, "d");
      // Trim the last whitespace
      slug = slug.replace(/\s*$/g, "");
      // Change whitespace to "-"
      slug = slug.replace(/\s+/g, "-");

      return slug;
    },
  },
};
</script>
